import { variantShadow } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import styled, { CSSProperties } from 'styled-components';

export interface VariantTextProps {
    text: string;
    style?: CSSProperties;
    className?: string;
}

export const VariantText = (props: VariantTextProps) => {
    return (
        <S_VariantText className={props.className} style={props.style}>
            <S_Span>{props.text}</S_Span>
        </S_VariantText>
    );
};

const S_VariantText = styled.div`
    max-width: 130px;
    line-height: 18px;
    max-height: 66px;
    background: #f7f7f7;
    padding: 6px 10px;
    border-radius: 10px;
    box-shadow: ${variantShadow};
    text-align: center;
    box-sizing: border-box;
    font-size: 13px;
    word-break: break-word;
    width: fit-content;
    font-family: ${({ theme }) => theme.fonts.semiBold};
`;

const S_Span = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;
